import type { RouteRecordRaw } from 'vue-router';
import { PUBLIC_LOCALE_PATTERN } from '@/seo/site';

/**
 * [#e03fdbc2] Публичные страницы: их делит клиентский роутер и сборка готового HTML.
 * Кабинет сюда не входит и остаётся обычным SPA.
 */
const L = `/:locale(${PUBLIC_LOCALE_PATTERN})?`;
const meta = { layout: 'public' };

export const publicRoutes: RouteRecordRaw[] = [
  { path: L, name: 'landing', component: () => import('@/pages/Landing.vue'), meta },
  { path: `${L}/articles`, name: 'articles', component: () => import('@/pages/Articles.vue'), meta },
  { path: `${L}/articles/:slug`, name: 'article', component: () => import('@/pages/Article.vue'), meta },
  { path: `${L}/abm`, name: 'abm', component: () => import('@/pages/Abm.vue'), meta },
  { path: `${L}/partners`, name: 'partners', component: () => import('@/pages/Partners.vue'), meta },
  { path: `${L}/privacy`, name: 'privacy', component: () => import('@/pages/Privacy.vue'), meta },
  { path: `${L}/contract`, name: 'contract', component: () => import('@/pages/Contract.vue'), meta },
  // [#022fa07d] Публичная инструкция постановки — без авторизации.
  { path: `${L}/faq/web`, name: 'faq-web', component: () => import('@/pages/FaqWeb.vue'), meta },
  // [#14e50863] Публичная инструкция станции: постановка + резервная копия — без авторизации.
  { path: `${L}/faq/station`, name: 'faq-station', component: () => import('@/pages/FaqStation.vue'), meta },
  { path: `${L}/faq/backup`, name: 'faq-backup', component: () => import('@/pages/FaqBackup.vue'), meta },
];
